import SimpleModel from './SimpleModel';

class Device extends SimpleModel {
  /** @type {number} */
  batteryChargeLevel = null;

  /** @type {string} */
  friendlyLastTransmission = null;

  /** @type {string} */
  friendlyStatus = null;

  /** @type {boolean} */
  hasMeaningfulConnectionStatus = null;

  /** @type {boolean} */
  hasTransmittedWithin30Days = null;

  /** @type {boolean} */
  isConnected = null;

  /** @type {boolean} */
  isOffline = null;

  /** @type {string} */
  key = null;

  /** @type {string} */
  lastTransmission = null;

  /** @type {string} */
  model = null;

  /** @type {string} */
  serial = null;

  /** @type {string} */
  vehicleKey = null;

  constructor(data = {}) {
    super();
    this.insert(data);
  }

  /**
   * Returns whether the curent device was made by Xirgo
   *
   * @return {boolean}
   */
  get isXirgo() {
    const { model } = this;
    const lowerModel = (model || '').toLowerCase();
    return lowerModel.startsWith('xt2469') || lowerModel.startsWith('xt2594');
  }
}

export default Device;
